import { z } from "zod";

export const contextSchema = z.object({
  propertyAddress: z.string().min(5, "Address is required").max(100),
  dateOfPropertyPurchase: z.coerce.date({ message: "Date of property purchase is required" }),
  homeValue: z.number().optional(),
});
export type ContextFormData = z.infer<typeof contextSchema>;
